__turbopack_context__.v({
  "helios-feature-tabs": "XpgtAq_helios-feature-tabs",
  "helios-feature-tabs__body": "XpgtAq_helios-feature-tabs__body",
  "helios-feature-tabs__heading": "XpgtAq_helios-feature-tabs__heading",
  "helios-feature-tabs__item": "XpgtAq_helios-feature-tabs__item",
  "helios-feature-tabs__list": "XpgtAq_helios-feature-tabs__list",
  "helios-feature-tabs__media": "XpgtAq_helios-feature-tabs__media",
  "helios-feature-tabs__media--inline": "XpgtAq_helios-feature-tabs__media--inline",
  "helios-feature-tabs__panel": "XpgtAq_helios-feature-tabs__panel",
  "helios-feature-tabs__trigger": "XpgtAq_helios-feature-tabs__trigger",
  "helios-feature-tabs__trigger--headline": "XpgtAq_helios-feature-tabs__trigger--headline",
  "helios-feature-tabs__trigger--open": "XpgtAq_helios-feature-tabs__trigger--open",
});
